import { makeStyles } from '@material-ui/core';
import { DataGrid, GridToolbar } from '@material-ui/data-grid';
import { Skeleton } from '@material-ui/lab';
import { useEffect, useState } from 'react';
import { data_grid_admin_users_column } from '../../../constants/dataGridHeaders';
import { IServiceUserInfo } from '../../../datasolvr/ServicesFacade';
import { IAdminUser } from '../../../interface/interface';
import { planEatApi } from '../../../planEatApi/PlanEatApi';
import { IEaterGroupContent, IUserContent, IVersionedObject } from '../../../planEatApi/PlanEatFacade';

const useStyles = makeStyles((theme: any) => ({
    container: {
        background: "white",
        boxShadow: '0px 4px 4px rgba(11, 37, 89, 0.1)',
        borderRadius: 8,
        minHeight: 400,
        padding: 30,
        width: "100%",
    },
    table: {
        marginTop: 25,
        height: 500
    },
}));


interface Props {

}

export const AdminUsers: React.FC<Props> = ({ }) => {
    const classes = useStyles()
    const [adminUsers, setAdminUsers] = useState<IAdminUser[]>()

    useEffect(() => {
        getAdminUser()
    }, [])

    function getAdminUser() {
        planEatApi.getServiceUsers()
            .then((response) => {
                const serviceUsers = response.data

                planEatApi.getUsers()
                    .then((response) => {
                        const users = response.data

                        planEatApi.getEaterGroups()
                            .then((response) => {
                                const eaterGroups = response.data
                                createAdminUserList(serviceUsers, users, eaterGroups)

                            })

                    })
            })
    }

    function createAdminUserList(
        serviceUsers: IServiceUserInfo[],
        users: IVersionedObject<IUserContent>[],
        eaterGroups: IVersionedObject<IEaterGroupContent>[]) {

        const adminUserList: IAdminUser[] = []
        serviceUsers.forEach((serviceUser) => {
            const user = users.find((user) => user.content.applicationUserId === serviceUser.content.id)
            let eaterGroup: IEaterGroupContent | undefined = undefined
            if (user) {
                eaterGroup = eaterGroups.find(item => item.content.id === user.content.eaterGroupId)?.content

                let eaterGroupName = ""
                if (eaterGroup) {
                    eaterGroupName = eaterGroup.eaterGroupName.length > 0 ? eaterGroup.eaterGroupName : "<empty name>"
                } else {
                    eaterGroupName = "<No Eater Group>"
                }

                adminUserList.push({
                    createdAt: serviceUser.versionDateTime,
                    email: serviceUser.content.id,
                    name: serviceUser.content.name,
                    eaterGroupName: eaterGroupName,
                    status: getStatusStr(serviceUser.content.name.length > 0, eaterGroup != undefined)
                })
            }
        })
        setAdminUsers(adminUserList)
    }

    function getStatusStr(haveName: boolean, haveEaterGroup: boolean) {
        let returnStr = ""

        if (haveName) {
            returnStr = "Onboarded"
        } else {
            returnStr = "User not verified"
        }

        if (!haveEaterGroup) {
            returnStr = returnStr + " + Not connected to EG"
        }

        return returnStr
    }

    return (
        <div className={classes.container}>
            <h1>Users</h1>
            <div className={classes.table}>
                {
                    adminUsers ?
                        <DataGrid
                            rows={adminUsers}
                            columns={data_grid_admin_users_column}
                            getRowId={(user) => user.email}
                            pageSize={20}
                            rowsPerPageOptions={[20]}
                            components={{ Toolbar: GridToolbar }}
                            disableColumnSelector
                            disableDensitySelector
                        />
                        :
                        <Skeleton variant="rect" width={"100%"} height={300} />
                }
            </div>
        </div>
    )
}